import { render, staticRenderFns } from "./GenericTableMobile.vue?vue&type=template&id=e7b01ccc&scoped=true"
import script from "./GenericTableMobile.vue?vue&type=script&lang=js"
export * from "./GenericTableMobile.vue?vue&type=script&lang=js"
import style0 from "./GenericTableMobile.vue?vue&type=style&index=0&id=e7b01ccc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b01ccc",
  null
  
)

export default component.exports